import { render, staticRenderFns } from "./DashBoardCard.vue?vue&type=template&id=a01e4348&scoped=true"
import script from "./DashBoardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashBoardCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashBoardCard.vue?vue&type=style&index=0&id=a01e4348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01e4348",
  null
  
)

export default component.exports